{
  "main": {
    "title": "Razpoložljivost",
    "nazaj": "Nazaj"
  },
  "nav": {
    "vnos": "Vnos",
    "zapisi": "Zapisi"
  },
  "labelsR": {
    "datum": "Datum",
    "uraOd": "Ura začetka",
    "uraDo": "Ura konca",
    "UrejanjeZapisa": "Urejanje zapisa",
    "namenVnosa": "Izberi vrsto leta",
    "namenMotorno": "letenje",
    "namenJadralno": "jadranje",
    "namenVleka": "vleka",
    "registracija": "Registracija",
    "filtriraj": "Filtriraj",
    "isci": "Išči in izberi",
    "izberi": "Pritisni Enter za izbiro",
    "odstrani": "Pritisni Enter za odstranitev",
    "neObstaja": "Ne najdem iskanega",
    "izbrano": "Izbrano",
    "praznaLista": "Ni plovil za prikaz",
    "opomba": "Opomba"
  },
  "obvestila": {
    "casVnosa": "Popravi čase! Ura začetka ne more biti večja od ure konca.",
    "praznoPlovilo": "Niste izbrali nobenega plovila. Izberite plovilo.",
    "prazenDatum": "Datum vnosa je prazen! Izberite željen datum"
  },
  "buttons": {
    "vnesiZapis": "Dodaj vnos",
    "urediZapis": "Posodobi",
    "brisiZapis": "Izbriši",
    "brisiIzbiro": "Počisti"
  }
}